var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3839 12.0643C7.36367 12.0643 5.71338 10.4785 5.71338 8.51681C5.71338 6.55518 7.36367 4.97852 9.3839 4.97852C11.4041 4.97852 13.0544 6.56435 13.0544 8.52598C13.0544 10.4876 11.4041 12.0643 9.3839 12.0643ZM9.3839 6.35352C8.15092 6.35352 7.13605 7.32518 7.13605 8.52598C7.13605 9.72681 8.14143 10.6985 9.3839 10.6985C10.6264 10.6985 11.6317 9.72681 11.6317 8.52598C11.6317 7.32518 10.6169 6.35352 9.3839 6.35352Z",
    fill: "#1E241B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38298 19.9421C7.97928 19.9421 6.56609 19.4288 5.46589 18.4113C2.66798 15.8079 -0.423946 11.6554 0.74264 6.71461C1.79541 2.23211 5.84527 0.224609 9.38298 0.224609C9.38298 0.224609 9.38298 0.224609 9.39246 0.224609C12.9302 0.224609 16.98 2.23211 18.0328 6.72378C19.1899 11.6646 16.098 15.8079 13.3001 18.4113C12.1999 19.4288 10.7867 19.9421 9.38298 19.9421ZM9.38298 1.59961C6.623 1.59961 3.07581 3.02044 2.13685 7.01711C1.11253 11.3346 3.91993 15.0563 6.46176 17.4121C8.10258 18.9429 10.6729 18.9429 12.3137 17.4121C14.846 15.0563 17.6534 11.3346 16.6481 7.01711C15.6996 3.02044 12.143 1.59961 9.38298 1.59961Z",
    fill: "#1E241B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location_.96b11359ea9dd40e7badf1cf357a41ad.svg";
export { ForwardRef as ReactComponent };